export const groupStatusContent = {
  Confirmed: {
    value: 'Confirmed balances',
    description: 'These balances are finalized and confirmed by your insurance company.'
  },
  GFE: {
    value: 'Good Faith Estimates',
    description:
      'This section outlines all appointments associated with your Good Faith Estimate (GFE), including both past and future appointments.'
  },
  Future: {
    value: 'Future appointments',
    description:
      'This invoice includes charges for upcoming appointments. Payments made now will be applied toward those visits and adjusted if your schedule or coverage changes.',
    icon: 'history-mono'
  },
  Past: { value: 'Past appointments', icon: 'calendar-reminder-mono' }
};

export const invoicePreviewKeys = [
  { label: 'Name', value: 'pt_name', property_of: 'patient' },
  { label: 'Patient ID', value: 'pt_id', property_of: 'patient' },
  { label: 'Date of birth', value: 'pt_dob', property_of: 'patient' },
  { label: 'Age', value: 'pt_age', property_of: 'patient' },
  { label: 'Gender', value: 'pt_gender', property_of: 'patient' },
  { label: 'Address', value: 'pt_address', property_of: 'patient' },
  { label: 'Phone', value: 'pt_phone', property_of: 'patient' },
  { label: 'Email', value: 'pt_email', property_of: 'patient' },
  { label: 'Date of service', value: 'date_of_service', property_of: 'invoice' },
  { label: 'Due date', value: 'due_date', property_of: 'invoice' }
];

export const aeobKeys = ['allowed_amount', 'ins_payment', 'ins_adjustment'];

export const insuranceTypes = [
  { label: 'Ins. primary', value: 'primary' },
  { label: 'Ins. secondary', value: 'secondary' },
  { label: 'Ins. tertiary', value: 'tertiary' }
];
